module.exports = __webpack_public_path__ + "static/PNRRLogo-57471c8c2acc94a223ccd1a447f61ec1.webp";